export default __webpack_public_path__ + "static/char-s-46-en-edbb252a421fda179afc0fe397e1db6c.webp";